export default "__VITE_ASSET__CLJTcmHI__"